import React from 'react';
import { Route, Switch } from 'react-router-dom';

import MyStatistic from 'features/myStatistics/view/mobile';

export const MyStatisticModule = <Route key="/my-statistic" path="/my-statistic" component={MyStatistic} />;
